import { useEffect, useRef } from "react";
import GoogleMeetServices from "../../../services/GoogleMeetService";
import { connectGmail } from "../../Email/GmailAuthHelper";

export default function GoogleCallback() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) return;

    // `state` carries the tenant subdomain origin plus a `flow` tag so this shared
    // callback page knows which BFF exchange to use for the popup's OAuth round-trip.
    const stateParam = params.get("state");
    let openerOrigin = window.location.origin;
    let flow = null;

    if (stateParam) {
      const decoded = decodeURIComponent(stateParam);
      try {
        const parsed = JSON.parse(decoded);
        openerOrigin = parsed.origin || openerOrigin;
        flow = parsed.flow || null;
      } catch {
        openerOrigin = decoded;
      }
    }

    // Google's redirect_uri is a fixed, non-tenant host (Google requires an exact
    // registered match, so it can't vary per subdomain) — on a tenant subdomain this
    // popup lands on a DIFFERENT origin than the one that started the flow, with no
    // access to that origin's localStorage/JWT. Both BFF connect calls are
    // authenticated, so bounce the popup back to the real tenant origin (carrying the
    // same code+state) before calling either.
    if ((flow === "meet" || flow === "gmail") && window.location.origin !== openerOrigin) {
      window.location.replace(
        openerOrigin + window.location.pathname + window.location.search
      );
      return;
    }

    done.current = true;

    // window.close() right after postMessage() races the browser's dispatch of
    // that message to the opener — some browsers tear the popup down before the
    // opener's event queue processes it, silently dropping the message. A short
    // delay lets the postMessage flush before the window goes away.
    const notifyOpenerAndClose = (message) => {
      window.opener.postMessage(message, openerOrigin);
      setTimeout(() => window.close(), 250);
    };

    if (flow === "meet") {
      GoogleMeetServices.connectMeet(code)
        .then(() => notifyOpenerAndClose({ type: "GOOGLE_OAUTH_SUCCESS" }))
        .catch(() => notifyOpenerAndClose({ type: "GOOGLE_OAUTH_ERROR" }));
      return;
    }

    if (flow === "gmail") {
      connectGmail(code)
        .then(() => notifyOpenerAndClose({ type: "GOOGLE_OAUTH_SUCCESS" }))
        .catch(() => notifyOpenerAndClose({ type: "GOOGLE_OAUTH_ERROR" }));
      return;
    }
  }, []);

  return <p>Connecting to Google…</p>;
}
